__webpack_require__.p = "/government-expenditures/";